// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `html,
body,
body > div {
	height: 100%;
}

.devTools {
	width: 100%;
	height: 99%;
}
`, "",{"version":3,"sources":["webpack://./src/platform/services/common/services.css"],"names":[],"mappings":"AAAA;;;CAGC,YAAY;AACb;;AAEA;CACC,WAAW;CACX,WAAW;AACZ","sourcesContent":["html,\nbody,\nbody > div {\n\theight: 100%;\n}\n\n.devTools {\n\twidth: 100%;\n\theight: 99%;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
